/**
 * Cross-feature voice session lock.
 * PageGuide (and others) check hasOtherHolder before starting audio.
 */

const holders = new Set();

/**
 * @param {string} id
 * @returns {boolean} true if acquired
 */
export function acquireVoiceSession(id) {
  if (!id) return false;
  if (holders.size > 0 && !holders.has(id)) return false;
  holders.add(id);
  return true;
}

/**
 * @param {string} id
 */
export function releaseVoiceSession(id) {
  if (!id) return;
  holders.delete(id);
}

/**
 * @param {string} [selfId] - ignore this holder when checking
 * @returns {boolean}
 */
export function hasOtherVoiceSession(selfId) {
  if (holders.size === 0) return false;
  if (selfId && holders.size === 1 && holders.has(selfId)) return false;
  if (selfId) {
    for (const id of holders) {
      if (id !== selfId) return true;
    }
    return false;
  }
  return holders.size > 0;
}

/** Test helper */
export function __resetVoiceSessionRegistry() {
  holders.clear();
}

export function __listVoiceSessionHolders() {
  return [...holders];
}
